module.exports = __webpack_public_path__ + "static/media/notcustomer.cf3214df.svg";